import { clientFetch } from '~/api/clientFetch';
import { LinkUrl } from '../types/model/linkUrl';

export type LinkUrlType = {
  link_urls: LinkUrl[];
};

export async function fetchLinkUrl(signOut: () => void): Promise<LinkUrlType> {
  const response = await clientFetch(
    '/link_urls',
    {
      method: 'GET',
    },
    signOut
  );
  return response.json();
}
